import { render, staticRenderFns } from "./digital_list.vue?vue&type=template&id=0d438fc4&scoped=true"
import script from "./digital_list.vue?vue&type=script&lang=js"
export * from "./digital_list.vue?vue&type=script&lang=js"
import style0 from "./digital_list.vue?vue&type=style&index=0&id=0d438fc4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d438fc4",
  null
  
)

export default component.exports